import React, { useState, useCallback, useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'

import TextInput from 'components/ui-elements/form/text-input'
import { ThemeContext } from 'styles/theme-provider'
import { LocaleContext } from 'styles/locale-provider'
import AnimatedCrossButton from '../ui-elements/animated-cross-btn'

import {
  Wrapper,
  Title,
  FormContent,
  FieldWrapper,
  Form,
  ButtonWrapper,
  BackWrapper,
  Button,
  ThankYouMessageTitle,
  ThankYouMessageCopy,
  Mark,
  PressInfo,
} from './index.styled'

const ContactForm = ({ onBackMobClick = () => {} }) => {
  const [submitting, setSubmitting] = useState(false)
  const [submited, setSubmited] = useState(false)

  const { resetForm, setResetForm } = useContext(ThemeContext)
  const { localeText } = useContext(LocaleContext)

  const form = useForm()
  const {
    reset,
    // formState: { isValid, isSubmitted },
  } = form

  useEffect(() => {
    if (resetForm) {
      setSubmited(false)
      setSubmitting(false)
      setResetForm(false)
    }
  }, [resetForm])

  const onSubmit = useCallback(
    (input) => {
      // console.log(input) //interest

      setSubmitting(true)

      fetch('/form-submission', {
        method: 'POST',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(input),
      })
        .then(() => {
          reset()
          setSubmitting(false)
          setSubmited(true)
        })
        .catch(() => {
          reset()
          setSubmitting(false)
          setSubmited(true)
        })
    },
    [reset],
  )

  return (
    <Wrapper>
      {!submited ? (
        <>
          <Title>
            {localeText['contact.title']}
            <PressInfo>
              {localeText['contact.press']}
              <a href="mailto:kanaimx@m18pr.com">kanaimx@m18pr.com</a>
            </PressInfo>
          </Title>

          <Form onSubmit={onSubmit} formProps={form}>
            <FormContent>
              <FieldWrapper>
                <TextInput
                  name="firstname"
                  title={localeText['contact.first.name']}
                  /*  required
                  rules={{ required: true }} */
                />
              </FieldWrapper>
              <FieldWrapper>
                <TextInput
                  name="lastname"
                  title={localeText['contact.last.name']}
                  /*  required
                  rules={{ required: true }} */
                />
              </FieldWrapper>
              <FieldWrapper>
                <TextInput
                  name="email"
                  title={localeText['contact.email']}
                  /*  required
                  rules={{
                    required: true,
                    pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
                  }} */
                />
              </FieldWrapper>
              <FieldWrapper>
                <TextInput
                  name="phone"
                  title={localeText['contact.phone']}
                  /* required
                  rules={{
                    required: true,
                    pattern: /^(?=.*[0-9])(?!\s*$)[0-9!@#$%^&*()_+={}\[\]:;"'<>,.?/~`\\|-]+$/,
                  }} */
                />
              </FieldWrapper>

              <FieldWrapper $fullWidth>
                <TextInput
                  name="message"
                  title={localeText['contact.message']}
                  className="arrow"
                />
              </FieldWrapper>
              {/*  <Mark>*Required fields</Mark> */}
            </FormContent>
            <ButtonWrapper>
              <Button as="button" $inverted type="submit" disabled={submitting}>
                {submitting ? 'Submitting' : localeText.submit}
              </Button>
            </ButtonWrapper>
            <BackWrapper>
              <AnimatedCrossButton
                onClick={onBackMobClick}
                className="white left mob-no-anim"
              />
            </BackWrapper>
          </Form>
        </>
      ) : (
        <>
          <ThankYouMessageTitle>
            {localeText['contact.thanks.title']}
          </ThankYouMessageTitle>
          <ThankYouMessageCopy>
            <Button
              as="button"
              $inverted
              type="button"
              onClick={() => {
                setSubmited(false)
                setSubmitting(false)
                setResetForm(false)
              }}
            >
              {localeText.back}
            </Button>
          </ThankYouMessageCopy>
        </>
      )}
    </Wrapper>
  )
}

export default ContactForm
